export default "__VITE_ASSET__D5VQQ9WH__"